module.exports = __webpack_public_path__ + "img/daruntereinfuegen.600c24c.svg";